import {
    differenceInDays,
    differenceInHours,
    differenceInMinutes,
    format,
} from 'date-fns'

// Time to display 'Just Now' in minutes
const JUST_NOW_DELTA = 15
const JUST_NOW_MESSAGE = 'Just now'

export const getReadableTimeSince = (
    publicationDateString: string,
    comparisonDateString: string,
    allowDayComparison = false,
    dateFormat = 'dd MMM yyyy',
): string => {
    const comparisonDate = new Date(comparisonDateString)
    const publicationDate = new Date(publicationDateString)
    const deltaInMinutes = differenceInMinutes(comparisonDate, publicationDate)

    // Don't display anything if the published date is in the future
    if (deltaInMinutes < 0) return ''

    if (deltaInMinutes <= JUST_NOW_DELTA) {
        return JUST_NOW_MESSAGE
    }

    // Display message if time since published is under an hour
    if (deltaInMinutes < 60) {
        return `${deltaInMinutes} mins ago`
    }

    // Display message if time since published is under a day
    const deltaInHours = differenceInHours(comparisonDate, publicationDate)

    if (deltaInHours === 1) {
        return `${deltaInHours} hour ago`
    }

    if (deltaInHours <= 24) {
        return `${deltaInHours} hours ago`
    }

    if (allowDayComparison) {
        const deltaInDays = differenceInDays(comparisonDate, publicationDate)

        if (deltaInDays === 1) {
            return `${deltaInDays} day ago`
        }

        if (deltaInDays <= 6) {
            return `${deltaInDays} days ago`
        }
    }

    // Display date if time since published is more than a day
    return format(publicationDate, dateFormat)
}
